import { useFormikContext } from 'formik';
import React, { useState } from 'react';

import Button from '../../../../../common/Button';
import { getAdCountryListForReview } from '../../../../../utils/reviewDerivation';
import type { AdFormValues } from '../../../adFormik';
import { ingestButton } from '../../configs';
import { useMultiCountryAssetIngestion } from '../../hooks/useMultiCountryAssetIngestion';

type Props = {
  displayRetry?: boolean;
};

const MultiCountryAssetIngestButton = ({ displayRetry }: Props): React.JSX.Element => {
  const [ingestBusy, setIngestBusy] = useState(false);
  const { startMultiCountryAssetIngestion } = useMultiCountryAssetIngestion();

  const { values, initialValues } = useFormikContext<AdFormValues>();
  const { creative } = values;

  const buttonLabel = displayRetry ? ingestButton.retryText : ingestButton.defaultText;
  const countries = getAdCountryListForReview(initialValues.lineItem.countries, initialValues.targetingTermValues);

  const handleClick = async (): Promise<void> => {
    setIngestBusy(true);

    await startMultiCountryAssetIngestion({
      countries,
      creativeLibraryId: creative.creativeLibraryId,
      creativeId: creative.id,
      vastUrl: creative.url,
    }).finally(() => setIngestBusy(false));
  };

  return (
    <Button
      data-testid="multi-country-asset-ingest-button"
      size="medium"
      title={buttonLabel}
      onClick={handleClick}
      disabled={ingestBusy}
    >
      {buttonLabel}
    </Button>
  );
};

export default MultiCountryAssetIngestButton;
